import React from "react";

const QuizButton = ({
  header,
  val,
  handleClick,
  disabled = false,
}: {
  header: string;
  val: string | number;
  handleClick: () => void;
  disabled: boolean;
}) => {
  return (
    <button onClick={() => handleClick()} disabled={disabled}>
      {header.toUpperCase() + ". " + val}
    </button>
  );
};

export default QuizButton;
